import { Col, List, Row } from 'antd'

import { closeSVG } from 'assets/svg/close'
import { V3Transaction } from 'models/v3-transaction'
import { useAppState } from 'state'
import { ListWrapper } from 'atom/list'
import TransactionPanelItem from './TransactionPanelItem'
import TransactionPanelRefund from './TransactionPanelRefund'
import TransactionPanelTotal from './TransactionPanelTotal'
import TransactionPanelAction from './TransactionPanelAction'

const DATADOG_LOGS_BASE = 'https://app.datadoghq.com/logs'

function buildDatadogLogsUrl(transaction: V3Transaction): string {
  const oneMinuteMs = 60 * 1000
  const chargerSerial = transaction.charger?.chargePointSerialNumber ?? ''
  const fromTs = new Date(transaction.startAt).getTime() - oneMinuteMs
  const toTs = transaction.endAt
    ? new Date(transaction.endAt).getTime() + oneMinuteMs
    : new Date(transaction.startAt).getTime() + 86400000 + oneMinuteMs // 86400000 = 24h in ms (ongoing transaction fallback)
  const query = `@charger_serial:${chargerSerial}`
  return `${DATADOG_LOGS_BASE}?query=${encodeURIComponent(query)}&from_ts=${fromTs}&to_ts=${toTs}&live=false&refresh_mode=paused`
}

interface props {
  loading: boolean
  selectedTransaction: V3Transaction
  onShowPanel: () => void
  reloadTransactions: () => void
}

const TransactionPanelCard = ({ loading, selectedTransaction, onShowPanel, reloadTransactions }: props) => {
  const { currentUser } = useAppState()
  const isAdmin = currentUser?.role === 'admin'
  const datadogUrl = buildDatadogLogsUrl(selectedTransaction)
  return (
    <ListWrapper $noSticky>
      <List
        header={
          <Row justify="space-between">
            <Col>
              {isAdmin ? (
                <>
                  ID #<a href={datadogUrl} target="_blank" rel="noopener noreferrer">{selectedTransaction.id}</a>
                </>
              ) : (
                <>ID #{selectedTransaction.id}</>
              )}
            </Col>
            <Col className="closeIcon" onClick={onShowPanel}>
              {closeSVG}
            </Col>
          </Row>
        }
        loading={loading}
        dataSource={[selectedTransaction]}
        renderItem={(transaction) => (
          <>
            <TransactionPanelItem transaction={transaction} />
            <TransactionPanelTotal financial={transaction.financial} transaction={transaction} />
            {transaction.refund && <TransactionPanelRefund transaction={transaction} />}
            <TransactionPanelAction transaction={transaction} reloadTransactions={reloadTransactions} />
          </>
        )}
      />
    </ListWrapper>
  )
}

export default TransactionPanelCard

